import noop from 'lodash/noop';
import React, { ReactNode } from 'react';
import Button from './Button';
import ModalWrapper, { ModalWrapperProps } from './Modal/ModalWrapper';

export const FORM_MODAL = 'FORM_MODAL';

export type FormModalProps = ModalWrapperProps & {
  form?: ReactNode;
  onClose?: () => void;
  showCancelBtn?: boolean;
};

const FormModal = ({
  form = null,
  onClose: handleCloseModal = noop,
  showCancelBtn = true,
  ...restProps
}: FormModalProps) => (
  <ModalWrapper onClose={handleCloseModal} {...restProps}>
    <div className="px-6 md:px-8 pb-6 md:pb-10">
      {form}
      {showCancelBtn && (
        <Button
          block
          variant="tertiary"
          className="text-gray-700"
          onClick={handleCloseModal}
        >
          Cancel
        </Button>
      )}
    </div>
  </ModalWrapper>
);

export default FormModal;
